import { render, staticRenderFns } from "./Recibo.vue?vue&type=template&id=a7bf90bc&"
import script from "./Recibo.vue?vue&type=script&lang=js&"
export * from "./Recibo.vue?vue&type=script&lang=js&"
import style0 from "./Recibo.vue?vue&type=style&index=0&id=a7bf90bc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports